import React, { useEffect } from "react";
import { useAppStore } from "../../../GlobalStore/GlobalStore.ts";

interface ErrorPopupProps {}

const ErrorPopup: React.FC<ErrorPopupProps> = ({ }) => {
    const dynamicStateObj = useAppStore((state: any) => state.dynamicStateObj);
    const { errorPopupMessage } = dynamicStateObj;
    const setDynamicStateObj = useAppStore((state: any) => state.setDynamicStateObj);

    const resetErrorState = () => {
        setDynamicStateObj({ visiblePopup: null, errorPopupMessage: null });
    };

    useEffect(() => {
        if (errorPopupMessage) {
            const timer = setTimeout(() => {
                resetErrorState();
            }, 2500);

            return () => clearTimeout(timer);
        }
    }, [errorPopupMessage]);

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white dark:bg-neutral-800 bg-opacity-75 dark:bg-opacity-60 p-6 rounded-lg shadow-lg text-center">
                <h2 className="text-xl font-bold mb-2 text-neutral-800 dark:text-white">Error</h2>
                <p className="text-red-600">{errorPopupMessage || ""}</p>
            </div>
        </div>
    );
}

export default ErrorPopup;